export const CONNECT_WALLET_TO_REVEAL_MESSAGE =
	"Connect a wallet to reveal this box."

export function connectedRevealWallet(account?: string | null): string {
	return (account || "").trim()
}

export function buildOpenBoxPayload(
	mysteryNftId: any,
	drops: { drop_id: any; quantity: any }[],
	userWalletAddress: string,
) {
	return {
		mystery_nft_id: mysteryNftId,
		drops,
		user_wallet_address: userWalletAddress,
	}
}
